/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useContext } from 'react';
import { Route, Redirect } from 'react-router-dom';


// local imports
import { AuthContext } from '../contexts/AuthContext';


const UnPrivateRoute = ({ component: Component, ...rest }) => {
    const { isAuthenticated, user } = useContext(AuthContext);

    return (
        <Route {...rest} render={props => {
            if (isAuthenticated) {
                if (user.selectedRole) {
                    return <Redirect to={{
                        pathname: `/${user.selectedRole}/dashboard`,
                        state: { from: props.location }
                    }} />
                } else {
                    return <Redirect to={{
                        pathname: `/user/landingScreen`,
                        state: { from: props.location }
                    }} />
                }
            }

            return <Component {...props} />

        }} />
    )
}

export default UnPrivateRoute;